"use client";

import QRCodeStyling from "qr-code-styling";
import { useEffect, useRef } from "react";
import { Button, Grid, Tooltip } from "antd";
import { IconDownload, IconQrcode } from "@tabler/icons-react";

import LOGO from "../assets/logos/Running Heros/Social Media Profile/qr_logo.png";
import { EventData } from "../models/event";

function ShareEvent({ url, event }: { url: string; event?: EventData }) {
  const qrCodeRef = useRef<QRCodeStyling | null>(null);

  if (!qrCodeRef.current) {
    qrCodeRef.current = new QRCodeStyling({
      width: 1000,
      height: 1000,
      type: "canvas",
      data: url,
      image: LOGO,
      margin: 10,
      qrOptions: {
        errorCorrectionLevel: "H",
      },
      imageOptions: {
        hideBackgroundDots: true,
        imageSize: 0.22,
        margin: 4,
        crossOrigin: "anonymous",
      },
      dotsOptions: {
        color: "#111827",
        type: "rounded",
      },
      backgroundOptions: {
        color: "#ffffff",
      },
      cornersSquareOptions: {
        color: "#2563eb",
        type: "extra-rounded",
      },
      cornersDotOptions: {
        color: "#111827",
        type: "dot",
      },
    });
  }

  useEffect(() => {
    qrCodeRef.current?.update({ data: url });
  }, [url]);

  const handleDownloadQR = async () => {
    try {
      const fileName = `${event?.name || "event"}-qr`;
      await qrCodeRef.current?.download({
        name: fileName,
        extension: "png",
      });
    } catch (error) {
      console.error(error);
    }
  };

  const screen = Grid.useBreakpoint();

  return screen.md ? (
    <Button
      icon={<IconDownload size={16} />}
      className="!bg-[#111827] !text-white !border-none !rounded-[8px] !font-medium !h-[36px] !px-[14px]"
      onClick={handleDownloadQR}
    >
      Download QR
    </Button>
  ) : (
    <Tooltip title="Download QR Code">
      <Button
        icon={<IconQrcode size={16} />}
        className="!bg-[#111827] !text-white !border-none !rounded-[8px] !font-medium !h-[36px] !w-[36px] !p-0"
        onClick={handleDownloadQR}
      />
    </Tooltip>
  );
}

export default ShareEvent;
